import React, { Component } from 'react';
import FirstPage from './FirstPage';
import Confirm from './Confirm';
import Thanks from './Thanks';
import scrollToElement from 'scroll-to-element';

import { CSSTransition } from 'react-transition-group'
const Fade = ({ children, ...props }) => (
  <CSSTransition
    {...props}

    timeout={600}
    mountOnEnter={true} unmountOnExit={true}
    classNames="fade"

  >
    {children}
  </CSSTransition>
);

const AlertWindow = function(e) {
  var msg = 'このページから移動しますか？入力した内容は保存されません。\n入力修正等はフォームの下の戻るボタンで戻ってください。';
  e.returnValue = msg;
}

const shopMaster = [
  {value:1,text:'青山店へのお問い合わせ'},
  {value:2,text:'銀座店へのお問い合わせ'},
  {value:3,text:'その他のお問い合わせ'}
];

class ContactApp extends Component {
  constructor(...args) {
    super(...args);
  //constructor(props) {
  //  super(props);
    this.state = {
      step: 1,
      show: true,
      fieldValues: {
      },
    };

    //setInterval(() => {
    //  this.setState({ show: !this.state.show })
    //}, 5000)
    //this.nextStep = this.nextStep.bind(this);
  }

  //componentDidMount() {
  //  this.nextStep();
  //  setInterval(this.nextStep, this.props.step);
  //}

  //saveValues(fields) {
  //    fieldValues = Object.assign({}, fieldValues, fields)
  //}
  sleep(msec) {
    return new Promise(function(resolve, reject){
      setTimeout(resolve, msec);
    });
  }

  fade() {
    this.setState({ show: !this.state.show })
  }

  nextStep() {
    var that = this;
    that.fade();

    scrollToElement('#registration-form', {
      offset: -180,
      ease: 'linear',
      duration: 300
    });
    that.sleep(600).then(function(){
      that.setState({
        step : that.state.step + 1
      })
    }).then(function(){
      that.fade();
    });

  }
  prevStep(e) {
    var that = this;
    e.preventDefault();

    that.fade();

    scrollToElement('#registration-form', {
      offset: -180,
      ease: 'linear',
      duration: 300
    });
    that.sleep(600).then(function(){
      that.setState({
        step : that.state.step - 1
      })
    }).then(function(){
      that.fade();
    });
  }

  saveValues(fields) {
    window.addEventListener('beforeunload', AlertWindow, false);
    let fieldValues = Object.assign({}, this.state.fieldValues, fields)
    this.setState({
      fieldValues: fieldValues
    })
  }

  clearValues() {
    window.removeEventListener('beforeunload', AlertWindow, false);
    this.setState({
      fieldValues: {}
    })
  }

  handleChange(e) {
    this.setState({textValue: e.target.value});
  }


  render() {
    let pages = '';
    switch (this.state.step) {
      case 1:
        pages = <FirstPage fieldValues={this.state.fieldValues} nextStep={this.nextStep.bind(this)}  fade={this.fade.bind(this)} saveValues={this.saveValues.bind(this)}/>
        break;
      case 2:
        pages = <Confirm fieldValues={this.state.fieldValues} nextStep={this.nextStep.bind(this)} prevStep={this.prevStep.bind(this)} shopMaster={shopMaster} />
        break;
      case 3:
        pages = <Thanks fieldValues={this.state.fieldValues}  nextStep={this.nextStep.bind(this)} clearValues={this.clearValues.bind(this)} />
        break;
      default:
        pages = ''
        break;
    }
    return (
      //<CSSTransition transitionName='fade'>
      //  { pages }
      //</CSSTransition>
      //<CSSTransition transitionName="example" transitionEnterTimeout={700} transitionLeaveTimeout={700}>
      <main>
        <div className='form__wrapper'>
          <form method="post" formNoValidate>
            <div className='form__body'>
              <Fade in={this.state.show}>
                { pages }
              </Fade>
            </div>
          </form>
        </div>
      </main>
    );
  }
}

export default ContactApp;



// WEBPACK FOOTER //
// ./src/contact/ContactApp.js